module.exports = __webpack_public_path__ + "static/media/technology_cn4.2079920e.png";